import { TranslationsContext } from '@teliaee/telia-translate';
import { observer } from 'mobx-react';
import * as React from 'react';
import { IFormHelperProps, Select } from 'telia-front-react';
import { useStores } from '../../../stores/RootStore';
import { BRANCH_FIELD_ID, helperInErrorState } from '../../../util/FieldHelperUtil';

const BranchSelection = observer((): React.JSX.Element => {
  const { reservationStore } = useStores();
  const { translate } = React.useContext(TranslationsContext);
  const [branchHelper, setBranchHelper] = React.useState<IFormHelperProps | undefined>(undefined);

  React.useEffect(() => {
    setBranchHelper(reservationStore.getBranchHelper(translate));
  }, [reservationStore.selectedBranch, reservationStore.hasReservationCreationFormSubmitted]);

  return (
    <Select
      id={BRANCH_FIELD_ID}
      label={translate('reservation.selectBranch')}
      placeholder={translate('reservation.selectBranch')}
      options={reservationStore.getBranchOptions(translate)}
      value={reservationStore.selectedBranch}
      onChange={reservationStore.selectBranchAndFetchTimes}
      errorMessage={helperInErrorState(branchHelper) ? (branchHelper.text as string) : undefined}
      isInvalid={helperInErrorState(branchHelper)}
    />
  );
});

export default BranchSelection;
